import { render, staticRenderFns } from "./Installation.vue?vue&type=template&id=9070700c&scoped=true&"
import script from "./Installation.vue?vue&type=script&lang=js&"
export * from "./Installation.vue?vue&type=script&lang=js&"
import style0 from "./Installation.vue?vue&type=style&index=0&id=9070700c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9070700c",
  null
  
)

export default component.exports